// Submenu visibility: hover mode uses CSS :hover + .is-open fallback for touch,
// click mode uses only .is-open class toggled on click/tap.
// Supports multiple sommaire blocks on the same page.
( () => {
    document.querySelectorAll( '.sommaire' ).forEach( ( wrapper ) => {
        const mode  = wrapper.getAttribute( 'data-menu-mode' ) || 'hover';
        const items = wrapper.querySelectorAll( '.sommaire__right-item' );

        function closeAll( except ) {
            items.forEach( ( item ) => {
                if ( item === except ) return;
                item.classList.remove( 'is-open' );
                const btn = item.querySelector( '.sommaire__right-btn' );
                if ( btn ) btn.setAttribute( 'aria-expanded', 'false' );
            } );
        }

        items.forEach( ( item ) => {
            const btn      = item.querySelector( '.sommaire__right-btn' );
            const closeBtn = item.querySelector( '.sommaire__submenu-close' );
            if ( ! btn ) return;

            // Close button inside submenu
            if ( closeBtn ) {
                closeBtn.addEventListener( 'click', () => {
                    item.classList.remove( 'is-open' );
                    btn.setAttribute( 'aria-expanded', 'false' );
                } );
            }

            if ( mode === 'hover' ) {
                item.addEventListener( 'mouseenter', () => {
                    item.classList.add( 'is-open' );
                    btn.setAttribute( 'aria-expanded', 'true' );
                } );
                item.addEventListener( 'mouseleave', () => {
                    item.classList.remove( 'is-open' );
                    btn.setAttribute( 'aria-expanded', 'false' );
                } );

                // Touch fallback
                btn.addEventListener( 'click', ( e ) => {
                    if ( window.matchMedia( '(hover: none)' ).matches ) {
                        e.preventDefault();
                        const isOpen = item.classList.toggle( 'is-open' );
                        btn.setAttribute( 'aria-expanded', String( isOpen ) );
                        closeAll( item );
                    }
                } );
            } else {
                btn.addEventListener( 'click', () => {
                    const isOpen = item.classList.toggle( 'is-open' );
                    btn.setAttribute( 'aria-expanded', String( isOpen ) );
                    closeAll( item );
                } );
            }
        } );

        // Close on click outside this sommaire
        document.addEventListener( 'click', ( e ) => {
            if ( ! e.target.closest( '.sommaire__right-item' ) ) {
                closeAll();
            }
        } );
    } );
} )();
